<template>
  <button
    class="mdc-fab mdc-fab--extended button"
    :class="{ 'will-fly': willPlaneFly }"
    aria-label="Favorite"
    @click="$listeners.click"
    @dragenter.prevent="showDumpDropArea"
    @dragover.prevent="showDumpDropArea"
    @dragleave.prevent="hideDumpDropArea"
    @drop.prevent="handleDrop"
  >
    <span class="mdc-fab__label">
      {{ dragging ? '解析用ファイルをアップロード' : '分析' }}
    </span>
    <md-icon class="mdc-fab__icon"
      ><font-awesome-icon class="icon" icon="paper-plane"
    /></md-icon>
  </button>
</template>

<script>
import { fromBase64 } from '@/util/string'

export default {
  props: {
    willPlaneFly: {
      type: Boolean,
      default: true,
    },
    enableDumpUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dragging: false,
    }
  },
  methods: {
    showDumpDropArea() {
      if (!this.enableDumpUpload) {
        return
      }
      this.dragging = true
    },
    hideDumpDropArea() {
      this.dragging = false
    },
    handleDrop(e) {
      if (!this.enableDumpUpload) {
        return
      }

      const dt = e.dataTransfer

      if (!dt) {
        // no dataTransfer in drop event
        this.hideDumpDropArea()
        return
      }

      if (!dt.files || dt.files.length === 0) {
        // no files in dataTransfer
        this.hideDumpDropArea()
        return
      }

      const file = dt.files[0] // 1ファイルのみ対応

      if (!file.name.endsWith('.giggle-dump')) {
        alert('対応していないファイル形式です')
        this.hideDumpDropArea()
        return
      }

      const reader = new FileReader()

      reader.onload = readEvent => {
        const raw = readEvent.target.result
        try {
          const dump = JSON.parse(fromBase64(raw))

          this.$emit('dump-uploaded', dump)
        } catch (e) {
          alert('ファイルの解析に失敗しました')
        } finally {
          this.hideDumpDropArea()
        }
      }

      reader.onerror = () => {
        alert('ファイルの読み込みに失敗しました')
        this.hideDumpDropArea()
      }

      reader.readAsText(file)
    },
  },
}
</script>

<style lang="scss" scoped>
// TODO Vue Materialのテーマ色を使う
$mdc-theme-secondary: #448aff;
@import '@material/fab/mdc-fab';

.icon {
  color: #fff;
  margin-right: 8px;
}

.button.will-fly:hover {
  .icon {
    transition: transform 0.4s ease-out;
    transform: translate(200%, -20px);
  }
}
</style>
